/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sendedparttwotillfive4Inputs */

const de__field_sendedparttwotillfive4 = /** @type {(inputs: _Field_Sendedparttwotillfive4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versand von Anmeldeunterlagen an Eltern`)
};

/**

* @param {_Field_Sendedparttwotillfive4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_sendedparttwotillfive4 = /** @type {((inputs?: _Field_Sendedparttwotillfive4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sendedparttwotillfive4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_sendedparttwotillfive4(inputs)
});
export { _field_sendedparttwotillfive4 as "_field_sendedPartTwoTillFive" }